module.exports = __webpack_public_path__ + "static/img/hiveboxx-mYxzG5NwDNs-unsplash_thumb.983714d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/hiveboxx-mYxzG5NwDNs-unsplash_thumb.png
// module id = Qzwd
// module chunks = 4